import { render, staticRenderFns } from "./SeriesMenu.vue?vue&type=template&id=8bd2be1a&"
import script from "./SeriesMenu.vue?vue&type=script&lang=js&"
export * from "./SeriesMenu.vue?vue&type=script&lang=js&"
import style0 from "./SeriesMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports